import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Recibís acceso digital inmediato después de la compra. Podés verlo desde tu celular, tablet o computadora en el momento.'
  }, {
    q: '¿Necesito saber astrología para entenderlo?',
    a: 'No. Está explicado de forma simple, directa y pensado para mujeres que quieren aplicar lo que leen, no estudiar teoría complicada.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones?',
    a: 'Sí. Tanto el Pack Esencial como el Megapack Élite incluyen los 6 Bonus completos sin costo extra.'
  }, {
    q: '¿Qué diferencia hay entre el Pack Esencial y el Megapack Élite?',
    a: 'El Pack Esencial te da el sistema completo para entender tu patrón y empezar a cambiarlo. El Megapack Élite suma los 2 ebooks avanzados para reconfigurar la dinámica del vínculo y dejar de ser la que siempre está disponible y esperando.'
  }, {
    q: '¿Esto sirve si estoy saliendo con alguien, si estoy sola o si quiero soltar a un ex?',
    a: 'Sí. El sistema está pensado para mujeres en distintas etapas: conociendo a alguien nuevo, atrapadas en un vínculo ambiguo, atravesando ghosting o intentando soltar definitivamente a un ex.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía total. Si sentís que no era para vos, pedís la devolución y listo. Sin preguntas ni formularios.'
  }, {
    q: '¿Vale la pena el Megapack Élite si ya hice terapia o leí sobre autoestima?',
    a: 'Sí. Esto no reemplaza la terapia. Te da estructura práctica, astrología aplicada y protocolos concretos para actuar distinto en el amor desde hoy mismo.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Podés pagar con tarjeta de crédito, débito y otros medios disponibles en el checkout.'
  }];
  return <section className="py-20 px-4 bg-mystic-900" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-white mb-12" data-id="element-100">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-101">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-102" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-mystic-700 rounded-xl overflow-hidden bg-mystic-800/30" data-id="element-103">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left hover:bg-mystic-800/50 transition-colors" data-id="element-104">
        <span className="font-bold text-white pr-4" data-id="element-105">{question}</span>
        <ChevronDown className={`w-5 h-5 text-gold-400 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-106" />
      </button>
      <AnimatePresence data-id="element-107">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-108">
            <div className="p-6 pt-0 text-slate-300 leading-relaxed border-t border-mystic-700/50 mt-2" data-id="element-109">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}